// extracted by mini-css-extract-plugin
export default {"highlight":"DevMockHighlight__highlight___ShO8H"};